export default {
    previewInvoices: [],
    pendingInvoices: [],
    invoiceHistory: [],
    filter: {
        availablePhotographers: []
    },
    html: '',
    checksum: 0,
    instructions: '',
    rejectMessage: ''
};
